import { render, staticRenderFns } from "./vCalculationMethodModal.vue?vue&type=template&id=a9a80fda&scoped=true"
import script from "./vCalculationMethodModal.vue?vue&type=script&lang=ts"
export * from "./vCalculationMethodModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a80fda",
  null
  
)

export default component.exports